import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  labelContainer: {
    position: 'absolute',
    top: 70, // Adjust this value to align the top edge
    left: '-20px', // Adjust this value to align the left edge
    transform: 'rotate(-45deg)',
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(0.5, 1),
    zIndex: 1,
    transformOrigin: '0 0', // Rotate around the top left corner
    width: '120px', // Adjust the width to fit the label text
    height: '20px', // Adjust the height to fit the label text
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  labelText: {
    color: 'white',
    fontWeight: 'bold',
  },
}));

const GiveawayLabel: React.FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.labelContainer}>
      <Typography className={classes.labelText}>Giveaway</Typography>
    </Box>
  );
};

export default GiveawayLabel;
